import { Alert, Icon, Tooltip } from "@mui/material";
import { brandIconButtonSx } from "common/assets/theme/components/brandButtonSx";
import DataTable from "common/components/implemented/Tables/DataTable/DataTables";
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";
import MDTypography from "common/components/MD/MDTypography";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ComunicazioniService from "services/API/Comunicazioni/ComunicazioniService";

function MessaggiTableRead({messaggi=[],chiamante}) {

  
  //  console.log("MessaggiTable="+id_proposta);
  //per passarmi la variabiule se ho salvato e far comparire l'alert
  const location = useLocation();
  //console.log(location);
    const { state } = location != null ? location : { state: { submitted: false, salvato: 'NO' } }; // Read values passed on state
 
      const msgAttributes = [];
      if (messaggi.length > 0) {
    
        messaggi.forEach(msg => {
    

         let vedi=  
(
<Tooltip title="Leggi">
    <MDButton
      component={Link}
      to="/messaggioRead"
      state={{ modo: 'vis', soggetto: msg, subject: null ,chiamante:chiamante}}
      variant="contained"
      iconOnly
      aria-label={`Leggi ${msg}`}
      sx={brandIconButtonSx}
    >
      <Icon aria-hidden="true">visibility</Icon>
    </MDButton>
  </Tooltip>
);


        

        
     


        msgAttributes.push({
          data_invio:msg.string_data_invio,
          oggetto: msg.oggetto,
          accettazione: msg.accettazioneSiNo,
          vedi:vedi,
         azienda:msg.azienda
         
        })
      });
    
      }
    
      const mcTableData = {
        columns: [
          { Header: "Destinatario", accessor: "azienda", width: "10%", align: "left" },
          { Header: "Oggetto Comunicazione", accessor: "oggetto", align: "left" },     
          { Header: "Data Ricezione", accessor: "data_invio", width: "20%", align: "left" },
          { Header: "", accessor: "vedi", align: "center", width: "5%", enableGlobalFilter: false },
  
        
        ],
    
        rows: msgAttributes,
    
    
      };
    
      const mypagination = { color: 'success', variant: "contained" };
     
     

return (

    <MDBox>
    <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">

      {(state != null && state.submitted  && (state.salvato==='INS' || state.salvato==='MOD') ) &&

        <Alert severity="success">Messaggio salvato con successo!</Alert>}
         {(state != null && state.submitted  && state.salvato==='DEL')  &&

<Alert severity="success">Messaggio eliminata con successo!</Alert>}
    </MDBox>
    <MDBox pt={3}>
      <DataTable canSearch={false}
        table={mcTableData}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={true}
        pagination={mypagination}
        noEndBorder
      />
    </MDBox>
    {(messaggi == null || messaggi.length === 0) &&
      <MDBox style={{ height: "200px" }} textAlign='center'>
        <MDTypography
          variant="button"
          fontWeight="regular"
          color="text"
          sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
        >
          Non ci sono Messaggi in archivio. Clicca su Nuovo per crearne uno!
        </MDTypography></MDBox>
    }
    </MDBox>

);

}
export default MessaggiTableRead;